import clsx from 'clsx'
import {
  HeaderNotificationsMenu,
  HeaderUserMenu,
  Search,
  ThemeModeSwitcher,
  useThemeMode,
} from '../../../partials'
import {useLayout} from '../../core'
import {defaultProfileImage} from '../../../../app/modules/core'
import {useAuth} from '../../../../app/modules/auth'
import {PodSelectModal} from './PodsModal'
import {KTIcon} from '../../../helpers'
import {useParams} from 'react-router-dom'
import secureLocalStorage from 'react-secure-storage'
import {FindPodIdByCode} from '../../../../app/modules/FindPodIdByPodCode'
import CryptoJS from 'crypto-js'

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'

const secretKey = process.env.REACT_APP_REQUEST_SIGN_SECRET_KEY || ''

const Navbar = () => {
  const {id} = useParams()
  const {mode} = useThemeMode()
  const {config} = useLayout()

  const podId = FindPodIdByCode()
  const userInfo = secureLocalStorage.getItem('user_info')
  let user_id = ''
  let auth_token = ''
  if (userInfo) {
    try {
      const parsedUserInfo = typeof userInfo === 'string' ? JSON.parse(userInfo) : userInfo
      ;({user_id, auth_token} = parsedUserInfo)
    } catch (e) {
      // handle parsing error if needed
    }
  }

  const payload = {
    pod_id: podId,
    user_id,
    auth_token,
    pod_code: id,
  }

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), secretKey).toString()
  const encoded = encodeURIComponent(encrypted)

  const url = `${process.env.REACT_APP_REQUEST_SIGN_PATH}/request-signatures?data=${encoded}`

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div> */}

      {/* <PrimaryOutlineButton onClick={() => {}} className='align-self-center py-3'> */}
      {/* <Link
        to='/pending-requests'
        className={`align-self-center btn btn-sm bg-${
          mode === 'dark' ? 'secondary' : 'white'
        } btn-outline btn-border border-primary btn-active-light-primary text-primary`}
        style={{paddingTop: '11px', paddingBottom: '11px'}}
      >
        Pending Requests
      </Link> */}

      {podId && id && (
        <a
          href={url}
          className={`d-none d-sm-inline align-self-center btn btn-md bg-${
            mode === 'dark' ? 'secondary' : 'white'
          } btn-outline border-primary text-primary btn-active-light-primary d-flex align-items-center ms-3`}
          // style={{paddingTop: '11px', paddingBottom: '11px'}}
        >
          <KTIcon iconName='plus' className='fs-2 text-primary' />
          {/* Show full text on sm+ devices */}
          <span className='d-none d-sm-inline'>Create Request</span>

          {/* Show short text on xs devices */}
          <span className='d-inline d-sm-none'>Create</span>
        </a>
      )}
      {/* </PrimaryOutlineButton> */}

      {/* <div className={`d-lg-none ${clsx('app-navbar-item', itemClass)}`}>
        <PodSelectModal />
      </div> */}

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass='btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px' />
      </div>

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <button
            className={clsx(
              'btn btn-icon',
              'btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px'
            )}
          >
            <KTIcon iconName='user' className={clsx('theme-light-hide', 'fs-1')} />
          </button>
        </div>
        <HeaderUserMenu />
      </div> */}

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Navbar}
